<!-- ================= Hero Banner ================= -->
<section class="hero-banner">
  <div class="hero-content">
    <h1 class="hero-title">
      加入环球巴士全生态合伙人<br />
      <span>构建您的被动收入矩阵</span>
    </h1>

    <!-- 业务快速跳转卡片 -->
    <div class="hero-cards">
      <a class="hero-card" href="/sales-introduction#section-universalbus">
        <span class="hero-card-icon material-icons">groups</span>
        <div class="hero-card-title">传统合租</div>
        <p class="hero-card-desc">UniversalBus<br />长期稳定 / 合作详谈</p>
      </a>
      <a
        class="hero-card hero-card--popcorn"
        href="/sales-introduction#section-popcorn"
      >
        <span class="hero-card-icon material-icons">play_circle</span>
        <div class="hero-card-title">客户端聚合</div>
        <p class="hero-card-desc">Popcorn<br />五大平台 / 客户端聚合</p>
      </a>
      <a
        class="hero-card hero-card--jiegehao"
        href="/sales-introduction#section-jiegehao"
      >
        <span class="hero-card-icon material-icons">schedule</span>
        <div class="hero-card-title">短期租赁</div>
        <p class="hero-card-desc">借个号<br />近百种会员 / 3天短租</p>
      </a>
    </div>
  </div>
</section>

<!-- ================= 业务板块 1: 环球巴士 (传统合租) ================= -->
<section id="section-universalbus" class="biz-section biz-section--white">
  <div class="container">
    <div class="biz-layout">
      <!-- 左侧：介绍 -->
      <div class="biz-info">
        <div class="biz-header">
          <div class="biz-icon">
            <img src="../../../assets/images/abou-page-logo.png" alt="" />
          </div>
          <h2 class="biz-title">环球巴士 (UniversalBus)</h2>
        </div>

        <p class="biz-desc">
          <strong>一站式全球数字内容订阅服务。</strong><br />
          面向有长期观影、音乐、AI 工具与效率软件需求的用户，提供
          Netflix、Disney+、YouTube Premium、ChatGPT Plus
          等服务的长期订阅方案。让用户更省心地使用全球数字内容服务。
        </p>

        <div class="biz-tags">
          <div class="biz-tag biz-tag--green">
            <h4>用户画像</h4>
            <p>18-35岁，大学生/白领，有长期追剧或AI办公需求。</p>
          </div>
          <div class="biz-tag biz-tag--green">
            <h4>核心优势</h4>
            <p>5年运营经验，支付宝原生支付，续费率高达55%。</p>
          </div>
        </div>

        <!-- 销售策略与合作政策 -->
        <div class="policy-box policy-box--green">
          <div class="policy-badge policy-badge--green">合伙人政策</div>
          <h3 class="policy-title policy-title--green">
            <span class="material-icons">savings</span>
            销售策略与合作政策
          </h3>
          <div class="policy-grid">
            <div>
              <p class="policy-item-label">推广建议：</p>
              <p class="policy-item-text">
                适合内容测评、工具使用指南、观影清单与校园/职场社群场景。
              </p>
            </div>
            <div>
              <p class="policy-item-label">合作权益：</p>
              <p class="policy-item-text">
                具体合作政策、结算方式与权益细节，将在商务沟通并确认合作意向后提供。
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧：视觉展示 -->
      <div class="biz-visual">
        <div class="ub-logo-grid">
          <div class="logo-grid-inner">
            <div class="logo-tile-card logo-tile">
              <img
                src="https://universalbus.cn/api/files/4547d25f61684948007e112a2860b67f"
                alt="Netflix logo"
                class="service-logo"
                loading="lazy"
              />
              <div class="logo-tile-label">Netflix</div>
              <div class="logo-tile-sub">4K 高级车</div>
            </div>
            <div class="logo-tile-card logo-tile">
              <img
                src="https://universalbus.cn/api/files/107c4324fe1e5cfdbe10a3f337ab9e74"
                alt="YouTube logo"
                class="service-logo"
                loading="lazy"
              />
              <div class="logo-tile-label">YouTube</div>
              <div class="logo-tile-sub">Premium</div>
            </div>
            <div class="logo-tile-card logo-tile">
              <img
                src="https://universalbus.cn/api/files/b1390f68aebd1ee1feb7fc28229ddb05"
                alt="Spotify logo"
                class="service-logo"
                loading="lazy"
              />
              <div class="logo-tile-label">Spotify</div>
              <div class="logo-tile-sub">音乐车</div>
            </div>
            <div class="logo-tile-card logo-tile">
              <div class="service-logo">
                <img
                  src="https://universalbus.cn/api/files/86beddd4c642b402e19c24684a081d93"
                  alt="ChatGPT logo"
                  class="service-logo"
                  loading="lazy"
                />
              </div>
              <div class="logo-tile-label">GPT-5.6</div>
              <div class="logo-tile-sub">独享/共享</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ================= 业务板块 2: 爆米花 ================= -->
<section id="section-popcorn" class="biz-section biz-section--gray">
  <div class="container">
    <div class="biz-layout biz-layout--reverse">
      <!-- 右侧：介绍 -->
      <div class="biz-info">
        <div class="biz-header">
          <div class="biz-icon">
            <img src="../../../assets/images/logo/popcorn.png" alt="" />
          </div>
          <h2 class="biz-title">爆米花</h2>
        </div>

        <p class="biz-desc">
          <strong>电脑端五大原版流媒体聚合观看工具。</strong><br />
          一个会员即可在电脑上纵览原版 Netflix、Disney+、Max、Prime
          Video、Crunchyroll 五大平台内容，适合希望集中管理观影入口的重度用户。
        </p>

        <div class="biz-tags">
          <div class="biz-tag biz-tag--red">
            <h4>用户画像</h4>
            <p>小白用户、技术苦手、多平台重度追剧党。</p>
          </div>
          <div class="biz-tag biz-tag--red">
            <h4>核心优势</h4>
            <p>统一入口，一键登录，减少账号切换，观影体验更顺畅。</p>
          </div>
        </div>

        <!-- 销售策略与合作政策 -->
        <div class="policy-box policy-box--red">
          <div class="policy-badge policy-badge--red">合伙人政策</div>
          <h3 class="policy-title policy-title--red">
            <span class="material-icons">pie_chart</span>
            销售策略与合作政策
          </h3>
          <div class="policy-grid">
            <div>
              <p class="policy-item-label">推广建议：</p>
              <p class="policy-item-text">
                适合通过客户端演示、使用流程说明和多平台内容清单进行介绍，帮助用户理解聚合观看体验。
              </p>
            </div>
            <div>
              <p class="policy-item-label">合作权益：</p>
              <p class="policy-item-text">
                根据渠道类型、内容形式与合作规模沟通匹配方案，签约前由商务专员详细说明。
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- 左侧：视觉展示 -->
      <div class="biz-visual">
        <div class="popcorn-visual">
          <!-- 模拟客户端界面 -->
          <div class="popcorn-mock">
            <img src="../../../assets/images/popcorn/introduction.png" alt="" />
          </div>
          <div class="popcorn-badge">五大平台聚合观看</div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ================= 业务板块 3: 借个号 (JieGeHao) ================= -->
<section id="section-jiegehao" class="biz-section biz-section--white">
  <div class="container">
    <div class="biz-layout">
      <!-- 左侧：介绍 -->
      <div class="biz-info">
        <div class="biz-header">
          <div class="biz-icon">
            <img src="../../../assets/images/logo/jiegehao.png" alt="" />
          </div>
          <h2 class="biz-title">借个号 (JieGeHao)</h2>
        </div>

        <p class="biz-desc">
          <strong>覆盖丰富会员类目的灵活租借平台。</strong><br />
          覆盖流媒体、AI
          工具、新闻资讯、生活服务、效率软件、学习娱乐等多类会员，目前已有近百种会员可租。平台以
          3 天短租为主，适合临时体验，可按具体场景短期租借。
        </p>

        <div class="biz-tags">
          <div class="biz-tag biz-tag--orange">
            <h4>用户画像</h4>
            <p>有短期体验、多品类会员需求的用户。</p>
          </div>
          <div class="biz-tag biz-tag--orange">
            <h4>核心优势</h4>
            <p>
              近百种会员可租，覆盖影音、AI、新闻、生活、效率、学习等多类场景；以3天短租为主，按需使用更轻量。
            </p>
          </div>
        </div>

        <!-- 销售策略与合作政策 -->
        <div class="policy-box policy-box--orange">
          <div class="policy-badge policy-badge--orange">合伙人政策</div>
          <h3 class="policy-title policy-title--orange">
            <span class="material-icons">sell</span>
            销售策略与合作政策
          </h3>
          <div class="policy-grid">
            <div>
              <p class="policy-item-label">推广建议：</p>
              <p class="policy-item-text">
                适合围绕"会员类目丰富、3天短租、按需使用"等场景进行介绍。建议展示清晰的类目清单、适用场景与使用说明
              </p>
            </div>
            <div>
              <p class="policy-item-label">合作权益：</p>
              <p class="policy-item-text">
                短租业务合作细节将结合渠道资源、内容方式与服务品类单独沟通。
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧：视觉展示 -->
      <div class="biz-visual">
        <div class="jgh-visual">
          <div class="jgh-inner">
            <div class="jgh-hero-card">
              <div class="jgh-hero-label">借个号会员租借</div>
              <div class="jgh-hero-title">近百种会员可租</div>
              <div class="jgh-hero-sub">
                近百种会员 / 统一3天短租 / 按需使用
              </div>
            </div>

            <div class="jgh-chip-grid">
              <div class="jgh-chip membership-chip">
                <div class="jgh-chip-header">
                  <span class="material-icons" style="color: #ff9900"
                    >live_tv</span
                  >
                  <span class="jgh-chip-label">流媒体</span>
                </div>
                <p class="jgh-chip-desc">观影追剧类会员</p>
              </div>
              <div class="jgh-chip membership-chip">
                <div class="jgh-chip-header">
                  <span class="material-icons" style="color: #ff9900"
                    >smart_toy</span
                  >
                  <span class="jgh-chip-label">AI 工具</span>
                </div>
                <p class="jgh-chip-desc">效率办公类会员</p>
              </div>
              <div class="jgh-chip membership-chip">
                <div class="jgh-chip-header">
                  <span class="material-icons" style="color: #ff9900"
                    >newspaper</span
                  >
                  <span class="jgh-chip-label">新闻资讯</span>
                </div>
                <p class="jgh-chip-desc">阅读资讯类会员</p>
              </div>
              <div class="jgh-chip membership-chip">
                <div class="jgh-chip-header">
                  <span class="material-icons" style="color: #ff9900"
                    >coffee</span
                  >
                  <span class="jgh-chip-label">生活服务</span>
                </div>
                <p class="jgh-chip-desc">日常权益类会员</p>
              </div>
            </div>

            <div class="jgh-feature-row service-row">
              <div class="jgh-feature-left">
                <div class="jgh-feature-icon-box">
                  <span class="material-icons">layers</span>
                </div>
                <div>
                  <div class="jgh-feature-label">会员类目丰富</div>
                  <div class="jgh-feature-sub">影音 / AI / 新闻 / 生活等</div>
                </div>
              </div>
              <div class="jgh-feature-badge">近百种</div>
            </div>

            <div class="jgh-feature-row service-row">
              <div class="jgh-feature-left">
                <div class="jgh-feature-icon-box">
                  <span class="material-icons">calendar_month</span>
                </div>
                <div>
                  <div class="jgh-feature-label">3天短租模式</div>
                  <div class="jgh-feature-sub">
                    临时体验、阶段性使用均可覆盖
                  </div>
                </div>
              </div>
              <div class="jgh-feature-badge">3天</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ================= 合作联系 ================= -->
<section class="contact-section" id="apply-form">
  <div class="container">
    <div class="contact-header">
      <h2 class="contact-title">准备开始合作了吗？</h2>
      <p class="contact-sub">
        添加企业微信后，请发送：想合作的平台 + 称呼 + 主要渠道。
      </p>
    </div>

    <div class="contact-card">
      <div class="contact-qr qr-placeholder">
        <img src="../../../assets/images/business_service_qrcode.jpg" alt="" />
      </div>
      <div class="contact-info">
        <h3 class="contact-info-title">扫码添加商务顾问</h3>
        <div class="contact-info-details">
          <p>
            <span class="contact-info-label">发送内容：</span>想合作的平台 +
            称呼 + 主要渠道
          </p>
          <p>
            <span class="contact-info-label">示例：</span>爆米花 / Alex /
            小红书与私域社群
          </p>
          <p class="contact-info-note">
            商务会根据渠道情况沟通合作方式、执行细节与相关权益。
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
